/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type FavoriteSellerInput = {
    readonly sellerPk: string;
    readonly userId: string;
    readonly favoriteId?: string | null;
    readonly clientMutationId?: string | null;
};
export type PdpSharedFollowDealerMutationVariables = {
    readonly input: FavoriteSellerInput;
    readonly userId: string;
};
export type PdpSharedFollowDealerMutationResponse = {
    readonly favoriteSeller: {
        readonly seller: {
            readonly id: string;
            readonly favoritesByUser: ReadonlyArray<{
                readonly serviceId: string | null;
            } | null> | null;
        } | null;
    } | null;
};
export type PdpSharedFollowDealerMutation = {
    readonly response: PdpSharedFollowDealerMutationResponse;
    readonly variables: PdpSharedFollowDealerMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "FavoriteSellerInput!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "userIds",
    "variableName": "userId"
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PdpSharedFollowDealerMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "favoriteSeller",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoriteSellerPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "seller",
            "storageKey": null,
            "args": null,
            "concreteType": "Seller",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "favoritesByUser",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "Favorite",
                "plural": true,
                "selections": [
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PdpSharedFollowDealerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "favoriteSeller",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoriteSellerPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "seller",
            "storageKey": null,
            "args": null,
            "concreteType": "Seller",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "favoritesByUser",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "Favorite",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "PdpSharedFollowDealerMutation",
    "id": "app-buyer-finding/235.0.0-2019-10-03T13:32:22.509Z/PdpSharedFollowDealerMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'd966d29320daefd69c4375c04412618c';
export default node;
